import { Component } from '@theme/component';

/** Intake reference shared between the visible Shopify Forms field and WhatsApp.
 * Only the random reference is stored in this tab; customer details and photos remain with Shopify Forms.
 */
class JubiloClinicIntake extends Component {
  #timer;
  #redirectTimer;
  #controller;
  #reference;
  #storageKey = 'jubilo-clinic-intake-reference';
  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    const params = new URLSearchParams(window.location.search);
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem(this.#storageKey) || 'null'); } catch {}
    if (params.get('solicitud') === 'enviada' && this.dataset.designMode !== 'true') {
      if (this.refs.success) this.refs.success.hidden = false;
      if (this.refs.app) this.refs.app.hidden = true;
      const code = saved?.code && Date.now() - saved.created < 86400000 ? saved.code : '';
      if (this.refs.successReference) this.refs.successReference.textContent = code;
      const message = code ? 'Hola Clínica Júbilo, envié la solicitud ' + code + ' con las fotos de mi paciente. Quiero continuar con su prediagnóstico.' : 'Hola Clínica Júbilo, envié el formulario con las fotos de mi paciente y quiero continuar con su prediagnóstico.';
      const url = new URL('https://wa.me/' + this.dataset.phone);
      url.searchParams.set('text', message);
      if (this.refs.continue) this.refs.continue.href = url.href;
      this.refs.success?.focus();
      // Consume the reference so reloading a confirmation page does not repeatedly open WhatsApp.
      if (code) {
        try { sessionStorage.removeItem(this.#storageKey); } catch {}
        this.#redirectTimer = setTimeout(() => window.location.assign(url.href), 1800);
      }
      return;
    }
    if (saved?.code && Date.now() - saved.created < 86400000) this.#reference = saved.code;
    else {
      const bytes = new Uint8Array(6);
      crypto.getRandomValues(bytes);
      const date = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Bogota', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()).replaceAll('-', '');
      this.#reference = 'JCL-' + date + '-' + Array.from(bytes, x => x.toString(16).padStart(2, '0')).join('').toUpperCase();
      try { sessionStorage.setItem(this.#storageKey, JSON.stringify({ code: this.#reference, created: Date.now() })); } catch {}
    }
    if (this.refs.reference) this.refs.reference.textContent = this.#reference;
    let attempts = 0;
    this.#timer = setInterval(() => {
      if (this.#connectField() || ++attempts > 120) { clearInterval(this.#timer); this.#timer = undefined; }
    }, 500);
    this.#connectField();
  }
  updatedCallback() {
    super.updatedCallback();
    if (this.#reference && this.refs.reference) this.refs.reference.textContent = this.#reference;
    if (this.#reference) this.#connectField();
  }
  /** Finds the rendered form field, including native open shadow DOM boundaries. */
  #connectField() {
    if (!this.refs.app) return false;
    const roots = [this.refs.app];
    while (roots.length) {
      const root = roots.pop();
      for (const field of root.querySelectorAll('textarea')) {
        const labels = { 'custom#qu_quieres_que_le_arreglemos': 'Qué quieres que le arreglemos', 'custom#la_historia_de_tu_peluche_opcional': 'La historia de tu peluche (opcional)' };
        if (labels[field.name]) field.setAttribute('aria-label', labels[field.name]);
      }
      const input = Array.from(root.querySelectorAll('input')).find(el => el.id === 'custom#nmero_de_solicitud' || el.name === 'custom#nmero_de_solicitud');
      if (input) {
        if (input.value !== this.#reference) {
          const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
          setter.call(input, this.#reference);
          input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
          input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
        }
        input.readOnly = true;
        return true;
      }
      for (const el of root.querySelectorAll('*')) if (el.shadowRoot) roots.push(el.shadowRoot);
    }
    return false;
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
    clearInterval(this.#timer);
    clearTimeout(this.#redirectTimer);
  }
}
if (!customElements.get('jubilo-clinic-intake-component')) customElements.define('jubilo-clinic-intake-component', JubiloClinicIntake);
